import { render, staticRenderFns } from "./BajaRegistro.vue?vue&type=template&id=b6b3a35e&"
import script from "./BajaRegistro.vue?vue&type=script&lang=js&"
export * from "./BajaRegistro.vue?vue&type=script&lang=js&"
import style0 from "./BajaRegistro.vue?vue&type=style&index=0&id=b6b3a35e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports